module.exports = __webpack_public_path__ + "static/media/10-1.2f173672.mp3";